import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut as firebaseSignOut
} from 'firebase/auth';
import { auth } from '../../config/fb-config';
import { setDocument } from '../../services/firestore-service';

export const signIn = (credentials) => {
    return (dispatch) => {
        signInWithEmailAndPassword(auth, credentials.email, credentials.password)
            .then(() => {
                dispatch({ type: 'LOGIN_SUCCESS' })
            }).catch((error) => {
                dispatch({ type: 'LOGIN_ERROR', error })
            });
    }
}

export const signOut = () => {
    return (dispatch) => {
        firebaseSignOut(auth).then(() => {
            dispatch({ type: 'SIGNOUT_SUCCESS' });
        });
    }
}

export const signUp = (newUser) => {
    return (dispatch) => {
        createUserWithEmailAndPassword(auth, newUser.email, newUser.password)
            .then((data) => {
                return setDocument('users', data.user.uid, {
                    firstName: newUser.first_name,
                    lastName: newUser.last_name,
                    email: newUser.email,
                    initials: newUser.first_name[0] + newUser.last_name[0]
                }).then(() => {
                    dispatch({ type: 'SIGNUP_SUCCESS' });
                })
            }).catch((error) => {
                dispatch({ type: 'SIGNUP_ERROR', error });
            })
    }
}

export const isAdmin = (payload) => dispatch => {
    dispatch({ type: 'IS_ADMIN', payload });
}
